import type { TMessages } from '@/types/TMessages'

export const messages = {
  communicationMethod: {
    email: 'Электронная \n почта',
    phone: 'Звонок на\n телефон',
  },
  communicationMethodData: {
    email: 'Электронная почта',
    phone: 'Звонок на телефон',
  },
  preferedMethod: 'Выберите предпочтительный способ связи',
  select: 'Выбрать',
} satisfies TMessages
